import React, { useMemo, memo } from "react"
import { getUserTopRole } from "@/utils"
import ErrorAccess from "@/components/common/ErrorAccess"

// RoleProtectRoute - check if the user can access the requested page
const RoleProtectRoute = memo(({ allowedRoles, loginUserRoles, children }) => {
    const topRole = useMemo(() => loginUserRoles && getUserTopRole(loginUserRoles), [loginUserRoles])
    const foundStatus = topRole && allowedRoles.find((role) => role === topRole.roleName)
    if (foundStatus) {
        return children
    }

    if (!foundStatus) {
        return <ErrorAccess errorComponent="Content" />
    }

    return null
})

export default RoleProtectRoute
